import { gsap, TimelineMax } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import lottie from 'lottie-web/build/player/lottie_light.min.js'

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)

const heroAnimation = {
    $heroWrapper: $('.js-section-hero'),
    lottieWrappers: gsap.utils.toArray('.js-lottie-hero'),
    lottieObjects: null,
    pauseTime: 180000, // 180000 = 3 minutes
    pauseInterval: null,
    storyAnimationIsPaused: false,
    heroLeavesTimeline: gsap.utils.toArray('.js-hero-leaves'),
    heroPlaneTimeline: gsap.utils.toArray('.js-hero-plane'),
    heroCloudsTimeline: gsap.utils.toArray('.js-hero-clouds'),
    heroContactsCloudsTimeline: gsap.utils.toArray('.js-hero-contacts-clouds'),
    heroSuremedCloudsTimeline: gsap.utils.toArray('.js-hero-suremed-clouds'),
    heroDatesTimeline: gsap.utils.toArray('.js-date'),
    heroTimelines: [],
    windowWidth: $(window).width(),
    windowHeight: $(window).height(),

    init: function () {
        // Preserve the initial styles for the leaves, so that on animation restart it uses them again
        ScrollTrigger.saveStyles(this.heroLeavesTimeline)
        ScrollTrigger.saveStyles(this.heroDatesTimeline)

        // Init and store lotties
        this.lottieObjects = this.lottieWrappers.map(item => {
            const lottieObj = this.initLottie(item)
            lottieObj.addEventListener('data_ready', () =>
                $(item).addClass('lottie-loaded')
            )
            return lottieObj
        })

        // If motion leaves present, create and store timeline
        if (this.heroLeavesTimeline.length) {
            this.initHeroLeavesTimeline()
        }

        ScrollTrigger.matchMedia({
            '(max-width: 1024px)': () => {
                // If motion leaves present, create and store timeline
                if (this.heroDatesTimeline.length) {
                    this.initHeroDatesTimelineMobile()
                }
            },
            '(min-width: 1025px)': () => {
                // If motion leaves present, create and store timeline
                if (this.heroDatesTimeline.length) {
                    this.initHeroDatesTimelineDesktop()
                }
            },
        })

        // If motion plane present, create and store timeline
        if (this.heroPlaneTimeline.length) {
            this.initHeroPlaneTimeline()
        }

        // If motion clouds present, create and store timeline
        if (this.heroCloudsTimeline.length) {
            this.initHeroCloudsTimeline()
        }

        if (this.heroContactsCloudsTimeline.length) {
            this.initContactsHeroCloudsTimeline()
        }

        if (this.heroSuremedCloudsTimeline.length) {
            this.initSuremedHeroCloudsTimeline()
        }

        // Kill and init anew to get correct element positions
        $(window).on('resize', () => {
            let isChangeSignificant = this.isResizeSignificant()
            if (this.heroTimelines.length && isChangeSignificant) {
                this.heroTimelines.map(item => item.progress(0).kill())
                this.heroTimelines = []
            }

            if (this.heroLeavesTimeline.length && isChangeSignificant) {
                this.initHeroLeavesTimeline()
            }

            if (this.heroCloudsTimeline.length && isChangeSignificant) {
                this.initHeroCloudsTimeline()
            }

            if (this.heroContactsCloudsTimeline.length && isChangeSignificant) {
                this.initContactsHeroCloudsTimeline()
            }

            if (this.heroSuremedCloudsTimeline.length && isChangeSignificant) {
                this.initSuremedHeroCloudsTimeline()
            }

            if (this.heroPlaneTimeline.length && isChangeSignificant) {
                this.initHeroPlaneTimeline()
            }

            ScrollTrigger.matchMedia({
                '(max-width: 1024px)': () => {
                    // If motion leaves present, create and store timeline
                    if (
                        this.heroDatesTimeline.length &&
                        isChangeSignificant &&
                        !this.storyAnimationIsPaused
                    ) {
                        this.initHeroDatesTimelineMobile()
                    }
                },
                '(min-width: 1025px)': () => {
                    // If motion leaves present, create and store timeline
                    if (
                        this.heroDatesTimeline.length &&
                        isChangeSignificant &&
                        !this.storyAnimationIsPaused
                    ) {
                        this.initHeroDatesTimelineDesktop()
                    }
                },
            })
        })

        this.playAllAnimations()

        ScrollTrigger.create({
            trigger: this.$heroWrapper,
            start: 'top bottom',
            end: 'bottom top',
            onToggle: ({ isActive }) => {
                clearTimeout(this.pauseInterval)
                if (isActive) {
                    this.playAllAnimations()
                    ScrollTrigger.matchMedia({
                        '(max-width: 1024px)': () => {
                            // If motion leaves present, create and store timeline
                            if (
                                this.heroDatesTimeline.length &&
                                !this.storyAnimationIsPaused
                            ) {
                                this.initHeroDatesTimelineMobile()
                            }
                        },
                        '(min-width: 1025px)': () => {
                            // If motion leaves present, create and store timeline
                            if (
                                this.heroDatesTimeline.length &&
                                !this.storyAnimationIsPaused
                            ) {
                                this.initHeroDatesTimelineDesktop()
                            }
                        },
                    })
                } else {
                    this.pauseAllAnimations()
                }
            },
        })
    },
    isResizeSignificant: function () {
        let currentWidth = $(window).width(),
            currentHeight = $(window).height(),
            step = 100,
            result = false

        if (
            currentWidth > this.windowWidth + step ||
            currentWidth < this.windowWidth - step ||
            currentHeight > this.windowHeight + step ||
            currentHeight < this.windowHeight - step
        ) {
            this.windowWidth = currentWidth
            this.windowHeight = currentHeight
            result = true
        } else {
            result = false
        }
        return result
    },
    playAllAnimations: function () {
        this.lottieObjects.map(item => item.play())
        if (this.heroTimelines.length) {
            this.heroTimelines.map(item => item.play())
        }
        this.storyAnimationIsPaused = false
        this.pauseInterval = setTimeout(() => {
            this.pauseAllAnimations()
            this.storyAnimationIsPaused = true
        }, this.pauseTime)
    },
    pauseAllAnimations: function () {
        this.lottieObjects.map(item => item.pause())
        if (this.heroTimelines.length) {
            this.heroTimelines.map(item => item.pause())
        }
    },
    initLottie: function (lottieWrapper) {
        const { name, path, aspectratio } = lottieWrapper.dataset
        return lottie.loadAnimation({
            container: lottieWrapper,
            renderer: 'svg',
            name,
            path,
            rendererSettings: {
                preserveAspectRatio: aspectratio
                    ? aspectratio
                    : 'xMinYMax meet',
                progressiveLoad: true,
            },
            autoplay: false,
        })
    },
    initHeroPlaneTimeline: function () {
        let planeTimeline = gsap.timeline({
            repeat: -1,
            repeatDelay: 30,
            paused: true,
        })
        gsap.set(this.heroPlaneTimeline, {
            xPercent: -50,
            yPercent: -50,
            transformOrigin: '50% 50%',
        })
        planeTimeline.to('#plane', {
            duration: 50,
            ease: 'linear',
            immediateRender: true,
            motionPath: {
                path: '#plane-path',
                align: '#plane-path',
            },
        })
        this.heroTimelines.push(planeTimeline)
        planeTimeline.restart()
    },
    initHeroCloudsTimeline: function () {
        let cloudsTimeline = gsap.timeline({
            repeat: -1,
            paused: true,
        })
        gsap.set(this.heroCloudsTimeline, {
            xPercent: -100,
            yPercent: -50,
            transformOrigin: '100% 50%',
        })
        cloudsTimeline
            .to('#clouds-1', {
                duration: 180,
                ease: 'linear',
                immediateRender: true,
                motionPath: {
                    path: '#clouds-path',
                    align: '#clouds-path',
                },
            })
            .to(
                '#clouds-2',
                {
                    duration: 160,
                    ease: 'linear',
                    immediateRender: true,
                    motionPath: {
                        path: '#clouds-path',
                        align: '#clouds-path',
                    },
                },
                //Both  clouds-1 and 2 will start simultaneously
                '0'
            )
        this.heroTimelines.push(cloudsTimeline)
        cloudsTimeline.restart()
    },
    initContactsHeroCloudsTimeline: function () {
        let cloudsTimeline = gsap.timeline({
            repeat: -1,
            paused: true,
        })
        gsap.set(this.heroSuremedCloudsTimeline, {
            xPercent: -100,
            yPercent: -50,
            transformOrigin: '100% 50%',
        })
        cloudsTimeline
            .to('#contacts-clouds-1', {
                duration: 60,
                ease: 'linear',
                immediateRender: true,
                motionPath: {
                    path: '#clouds-path',
                    align: '#clouds-path',
                },
            })
            .to(
                '#contacts-clouds-2',
                {
                    duration: 50,
                    ease: 'linear',
                    immediateRender: true,
                    motionPath: {
                        path: '#clouds-path',
                        align: '#clouds-path',
                    },
                },
                '-20'
            )
        this.heroTimelines.push(cloudsTimeline)
        cloudsTimeline.restart()
    },
    initSuremedHeroCloudsTimeline: function () {
        let cloudsTimeline = gsap.timeline({
            repeat: -1,
            paused: true,
        })
        gsap.set(this.heroCloudsTimeline, {
            xPercent: -100,
            yPercent: -50,
            transformOrigin: '100% 50%',
        })
        cloudsTimeline
            .to('#suremed-clouds-1', {
                duration: 100,
                ease: 'linear',
                immediateRender: true,
                motionPath: {
                    path: '#clouds-path',
                    align: '#clouds-path',
                },
            })
            .to(
                '#suremed-clouds-2',
                {
                    duration: 100,
                    ease: 'linear',
                    immediateRender: true,
                    motionPath: {
                        path: '#clouds-path',
                        align: '#clouds-path',
                    },
                },
                '-25'
            )
            .to(
                '#suremed-clouds-3',
                {
                    duration: 100,
                    ease: 'linear',
                    immediateRender: true,
                    motionPath: {
                        path: '#clouds-path',
                        align: '#clouds-path',
                    },
                },
                '-25'
            )
            .to(
                '#suremed-clouds-4',
                {
                    duration: 100,
                    ease: 'linear',
                    immediateRender: true,
                    motionPath: {
                        path: '#clouds-path',
                        align: '#clouds-path',
                    },
                },
                '-10'
            )
        this.heroTimelines.push(cloudsTimeline)
        cloudsTimeline.restart()
    },
    initHeroLeavesTimeline: function () {
        let leavesTimeline = gsap.timeline({
            repeat: -1,
            repeatDelay: 8,
            paused: true,
        })
        gsap.set(this.heroLeavesTimeline, {
            xPercent: -50,
            yPercent: -50,
            transformOrigin: '50% 50%',
        })
        leavesTimeline
            .to('#leaf-1', {
                duration: 6,
                immediateRender: true,
                rotation: 720,
                ease: 'linear',
                motionPath: {
                    path: '#leaf-path-1',
                    align: '#leaf-path-1',
                },
            })
            .to(
                '#leaf-2',
                {
                    duration: 6.5,
                    immediateRender: true,
                    rotation: 480,
                    ease: 'linear',
                    motionPath: {
                        path: '#leaf-path-2',
                        align: '#leaf-path-2',
                    },
                },
                '-=5.65'
            )
            .to(
                '#leaf-3',
                {
                    duration: 7,
                    immediateRender: true,
                    rotation: 360,
                    ease: 'linear',
                    motionPath: {
                        path: '#leaf-path-3',
                        align: '#leaf-path-3',
                    },
                },
                '-=6'
            )
            .to(
                '#leaf-4',
                {
                    duration: 6,
                    immediateRender: true,
                    ease: 'linear',
                    motionPath: {
                        path: '#leaf-path-4',
                        align: '#leaf-path-4',
                        autoRotate: true,
                    },
                },
                '-=5'
            )
            .to(
                '#leaf-5',
                {
                    duration: 6,
                    immediateRender: true,
                    ease: 'linear',
                    motionPath: {
                        path: '#leaf-path-5',
                        align: '#leaf-path-5',
                        autoRotate: true,
                    },
                },
                '-=4.5'
            )
        this.heroTimelines.push(leavesTimeline)
        leavesTimeline.restart()
    },

    initHeroDatesTimelineMobile: function () {
        let tlMobile = new TimelineMax({
            repeat: -1,
        })

        let object = {
            el: '.js-date',
            duration: 30,
        }
        tlMobile
            .set(object.el, {
                x: '+=10',
                transformOrigin: 'center',
                opacity: '1',
            })
            .staggerFromTo(
                object.el,
                object.duration,
                {
                    x: '-=10vw',
                    transformOrigin: 'center',
                },
                {
                    x: '+=250vw',
                },
                '8.3'
            )
        this.heroTimelines.push(tlMobile)
        tlMobile.restart()
    },

    initHeroDatesTimelineDesktop: function () {
        $('.js-date').each(function (i, element) {
            $(element).css('opacity', '0')
            let timeMax = new TimelineMax({
                delay: i * 10,
                repeat: -1,
                repeatDelay: 50,
                ease: 'linear',
            })
            timeMax.to(element, 1, { opacity: 1 })
            timeMax.to(element, 30, { x: '100vw', opacity: 0 })
            heroAnimation.heroTimelines.push(timeMax)
        })
    },
}

$(window).on('load', () => {
    heroAnimation.init()
})
